module.exports = __webpack_public_path__ + "img/neimenggu.916e2de6.png";